import getAllScenarioStores from '../selectors/getAllScenarioStores';
import { refreshSchedulingGrid } from 'owa-calendar-scheduling-grid';
import { orchestrator } from 'satcheljs';
import {
    calendarEventsAdded,
    calendarEventsRemoved,
    calendarEventUpdated,
} from 'owa-calendar-events-store';

// TODO VSO 46548 investigate exposing controlled and uncontrolled versions of scheduling grid
export const calendarEventsAddedOrchestrator = orchestrator(
    calendarEventsAdded,
    refreshUncontrolledGrids
);
export const calendarEventsRemovedOrchestrator = orchestrator(
    calendarEventsRemoved,
    refreshUncontrolledGrids
);
export const calendarEventUpdatedOrchestrator = orchestrator(
    calendarEventUpdated,
    refreshUncontrolledGrids
);

function refreshUncontrolledGrids() {
    getAllScenarioStores().forEach(refreshSchedulingGrid);
}
